import { render, staticRenderFns } from "./Profesional.vue?vue&type=template&id=2852c826&scoped=true&"
import script from "./Profesional.vue?vue&type=script&lang=js&"
export * from "./Profesional.vue?vue&type=script&lang=js&"
import style0 from "./Profesional.vue?vue&type=style&index=0&id=2852c826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2852c826",
  null
  
)

export default component.exports